import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { AccountStorage } from "@services/account";
import { mapActions, mapGetters } from "vuex";
var accountStorage = new AccountStorage();
export default {
  data: function data() {
    return {};
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    cardInfo: 'cardInfo'
  })), {}, {
    totalCount: function totalCount() {
      if (this.cardInfo.ocCartLists) {
        return this.cardInfo.ocCartLists.length;
      }
      return 0;
    }
  }),
  inject: ["reload"],
  methods: _objectSpread(_objectSpread({}, mapActions(['findCardList'])), {}, {
    reloadCart: function reloadCart() {
      //如果页面在购物车页面，需要刷新一下页面
      if (this.$route.name == 'v2-shopcard') {
        this.reload();
      }
    },
    //获取用户ID
    getUserId: function getUserId() {
      var userInfo = accountStorage.getCacheUserInfo();
      if (userInfo) {
        return userInfo.userId;
      }
      return;
    },
    //删除购物车某个产品
    shopCardDel: function shopCardDel(productId) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var $this, url, param;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              $this = _this;
              url = "/pjyy-deepexi-order-center/api/v1/cart/removeCartList";
              param = {
                productId: [productId],
                userId: _this.getUserId()
              };
              _this.$getHttpClient().post(url, param).then(function (result) {
                if (result.data.code == '200') {
                  _this.$messageTip("删除成功！", 'success');
                  //刷新购物车
                  _this.findCardList().then(function () {
                    $this.reloadCart();
                  });
                }
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    delAll: function delAll() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var arr, $this, url, param;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              arr = [];
              $this = _this2;
              _this2.cardInfo.ocCartLists.forEach(function (t) {
                arr.push(t.productId);
              });
              url = "/pjyy-deepexi-order-center/api/v1/cart/removeCartList";
              param = {
                productId: arr,
                userId: _this2.getUserId()
              };
              _this2.$getHttpClient().post(url, param).then(function (result) {
                if (result.data.code == '200') {
                  _this2.$messageTip("删除成功！", 'success');
                  //刷新购物车
                  _this2.findCardList().then(function () {
                    $this.reloadCart();
                  });
                }
              });
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  })
};